import { render, staticRenderFns } from "./ParsewordArchiveList.vue?vue&type=template&id=10c695e6&scoped=true"
import script from "./ParsewordArchiveList.vue?vue&type=script&lang=js"
export * from "./ParsewordArchiveList.vue?vue&type=script&lang=js"
import style0 from "./ParsewordArchiveList.vue?vue&type=style&index=0&id=10c695e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c695e6",
  null
  
)

export default component.exports